<!--

https://www.primefaces.org/primeng/showcase/#/primeflex/formlayout

  <div class="card">
    <h5>Advanced</h5>
    <div class="fluid formgrid grid">
        <div class="field col-12 p-md-6">
            <label for="firstname6">Firstname</label>
            <input id="firstname6" type="text" pInputText>
        </div>
        <div class="field col-12 p-md-6">
            <label for="lastname6">Lastname</label>
            <input id="lastname6" type="text" pInputText>
        </div>
        <div class="field col-12">
            <label for="address">Address</label>
            <textarea id="address" type="text" rows="4" pInputTextarea></textarea>
        </div>
        <div class="field col-12 p-md-6">
            <label for="city">City</label>
            <input id="city" type="text" pInputText>
        </div>
        <div class="field col-12 p-md-3">
            <label for="state">State</label>
            <p-dropdown inputId="state" [options]="states" [(ngModel)]="selectedState" placeholder="Select" optionLabel="name"></p-dropdown>
        </div>
        <div class="field col-12 p-md-3">
            <label for="zip">Zip</label>
            <input id="zip" type="text" pInputText>
        </div>
    </div>
</div>

-->
<p-toast></p-toast>
<p-dialog id="globalsettingsdialog"
          header="Параметры"
          [(visible)]="display"
          [modal]="true"
          width="300" height="200"
          styleClass=".globalsettingsdialog"
          [resizable]="false"
          (onShow)="onShowDialog()"
          (onHide)="onHideDialog()">
  <ng-template pTemplate="content">
    <p-tabView style="width: 500px;">
      <p-tabPanel header="Raw data">
        <div class="fluid formgrid grid">
          <div class="field col-12 xl:col-2 p-md-3">
            <label for="mainCompanyId1">mainCompanyId</label>
            <input id="mainCompanyId1" type="text" pInputText [(ngModel)]="edited.mainCompanyId">
          </div>
          <div class="field col-12 xl:col-2 p-md-3">
            <label for="mainPersonId2">mainPersonId</label>
            <input id="mainPersonId2" type="text" pInputText [(ngModel)]="edited.mainPersonId">
          </div>
          <div class="field col-12 xl:col-2 p-md-3">
            <label for="vatValue3">vatValue</label>
            <input id="vatValue3" type="text" pInputText [(ngModel)]="edited.vatValue">
          </div>
          <div class="field col-12 xl:col-2 p-md-3">
            <label for="mainCurrencyId4">mainCurrencyId</label>
            <input id="mainCurrencyId4" type="text" pInputText [(ngModel)]="edited.mainCurrencyId">
          </div>
          <div class="field col-12 xl:col-2 p-md-3">
            <label for="balanceCurrencyId5">balanceCurrencyId</label>
            <input id="balanceCurrencyId5" type="text" pInputText [(ngModel)]="edited.balanceCurrencyId">
          </div>
          <div class="field col-12 xl:col-2 p-md-3">
            <label for="mainStockId6">mainStockId</label>
            <input id="mainStockId6" type="text" pInputText [(ngModel)]="edited.mainStockId">
          </div>
          <div class="field col-12 xl:col-2 p-md-3">
            <label for="impStockId7">impStockId</label>
            <input id="impStockId7" type="text" pInputText [(ngModel)]="edited.impStockId">
          </div>
          <div class="field col-12 xl:col-2 p-md-3">
            <label for="auxStockId8">auxStockId</label>
            <input id="auxStockId8" type="text" pInputText [(ngModel)]="edited.auxStockId">
          </div>
          <div class="field col-12 xl:col-2 p-md-3">
            <label for="impCountFlag9">impCountFlag</label>
            <input id="impCountFlag9" type="text" pInputText [(ngModel)]="edited.impCountFlag">
          </div>
          <div class="field col-12 xl:col-2 p-md-3">
            <label for="auxStockId10">auxStockId</label>
            <input id="auxStockId10" type="text" pInputText [(ngModel)]="edited.auxStockId">
          </div>
          <div class="field col-12 xl:col-2 p-md-3">
            <label for="manDepartmentId11">manDepartmentId</label>
            <input id="manDepartmentId11" type="text" pInputText [(ngModel)]="edited.manDepartmentId">
          </div>
          <div class="field col-12 xl:col-2 p-md-3">
            <label for="auxDepartmentId12">auxDepartmentId</label>
            <input id="auxDepartmentId12" type="text" pInputText [(ngModel)]="edited.auxDepartmentId">
          </div>
          <div class="field col-12 xl:col-2 p-md-3">
            <label for="paidDepartmentId13">paidDepartmentId</label>
            <input id="paidDepartmentId13" type="text" pInputText [(ngModel)]="edited.paidDepartmentId">
          </div>
          <div class="field col-12 xl:col-2 p-md-3">
            <label for="cashDepartmentId14">cashDepartmentId</label>
            <input id="cashDepartmentId14" type="text" pInputText [(ngModel)]="edited.cashDepartmentId">
          </div>
          <div class="field col-12 xl:col-2 p-md-3">
            <label for="defaultTradeCompanyId15">defaultTradeCompanyId</label>
            <input id="defaultTradeCompanyId15" type="text" pInputText [(ngModel)]="edited.defaultTradeCompanyId">
          </div>
          <div class="field col-12 p-md-6">
            <label for="urlPrefixString16">urlPrefixString</label>
            <input id="urlPrefixString16" type="text" pInputText [(ngModel)]="edited.urlPrefixString">
          </div>
        </div>
      </p-tabPanel>
      <p-tabPanel header="Основная организация">
        <div class="p-formgroup-inline">
          <div class="field col-12 p-md-6">
            <label for="mainCompanyDd">Компания</label>

            <p-dropdown id="mainCompanyDd"
                        [options]="clientslistMC"
                        optionLabel="CLIENTSNAME"
                        [(ngModel)]="clientMC"
                        name="clientMC"
                        placeholder="Выберите компанию"
                        filterPlaceholder="Поиск..."
                        [filter]="true"
                        [showClear]="true"
                        [required]="true"
                        style="max-width: 30rem;"
                        [autofocusFilter]="false" 
                        (onClick)="onClickMainCompany($event)"
                        (onChange)="onChangeMainCompany($event)"></p-dropdown>
          </div>
          <p-button label="Новая компания..." (click)="onNewCompany()"></p-button>
        </div>
        <div class="p-formgroup-inline">
          <app-companyselector
                               [parentCompany]="(clientslistMC ? clientslistMC.CLIID : 0)"
                               [selectedID]="(clientslistMC ? clientslistMC.CLIID : 0)"
                               [_disabled]="(clientslistMC || null)"
          ></app-companyselector>
        </div>
        <div class="fluid formgrid grid">
          <div class="field col-12 p-md-6">
          </div>
          <div class="field col-12 p-md-6">
          </div>
          <div class="field col-12 p-md-6">
            <label for="lastname6">Last name</label>
            <input id="lastname6" type="text" pInputText>
          </div>
          <div class="field col-12">
            <label for="address">Address</label>
            <textarea id="address" type="text" rows="4" pInputTextarea></textarea>
          </div>
          <div class="field col-12 p-md-6">
            <label for="city">City</label>
            <input id="city" type="text" pInputText>
          </div>
          <div class="field col-12 p-md-3">
            <label for="state">State</label>
            <p-dropdown inputId="state" [options]="states" [(ngModel)]="selectedState" [autofocusFilter]="false" placeholder="Select" optionLabel="name"></p-dropdown>
          </div>
          <div class="field col-12 p-md-3">
            <label for="zip">Zip</label>
            <input id="zip" type="text" pInputText>
          </div>
        </div>
        <p-button label="Группы доступа..." (click)="onAccessGroup()"></p-button>
      </p-tabPanel>
      <p-tabPanel header="Установки валют">
        <div class="fluid formgrid grid">
          <div class="field col-12 p-md-6">
            <app-currencyselector></app-currencyselector>
          </div>
        </div>
      </p-tabPanel>
      <p-tabPanel header="Склады">
        <div class="fluid formgrid grid">
          <div class="field col-12 p-md-6">
            Content 3
          </div>
        </div>
      </p-tabPanel>
      <p-tabPanel header="Прочее">
        <div class="fluid formgrid grid">
          <div class="field col-12 p-md-6">
            Content 4
          </div>
        </div>
      </p-tabPanel>
    </p-tabView>
  </ng-template>
  <ng-template pTemplate="footer">
    <p-button label="ОК!" (click)="onConfirm('ok')"></p-button>
    <p-button label="Отмена" (click)="display=false"></p-button>
  </ng-template>
</p-dialog>
